export interface Category {
  id: number;
  name: string;
  slug: string;
  url: string;
}

export const categories: Category[] = [
  { id: 1, name: 'Обувь', slug: 'Shoes', url: 'https://kaspreadsheet.com/category-911-Shoes.html' },
  { id: 2, name: 'Худи / Свитера', slug: 'Hoodies-Sweaters', url: 'https://kaspreadsheet.com/search-912/name/Shoes.html' },
  { id: 3, name: 'Футболки', slug: 'T-Shirts', url: 'https://kaspreadsheet.com/search-913/name/Shoes.html' },
  { id: 4, name: 'Куртки', slug: 'Jackets', url: 'https://kaspreadsheet.com/search-914/name/Shoes.html' },
  { id: 5, name: 'Штаны / Шорты', slug: 'Pants-Shorts', url: 'https://kaspreadsheet.com/search-915/name/Shoes.html' },
  { id: 6, name: 'Головные уборы', slug: 'Headwear', url: 'https://kaspreadsheet.com/search-916/name/Shoes.html' },
  { id: 7, name: 'Комплекты', slug: 'Sets', url: 'https://kaspreadsheet.com/search-917/name/Shoes.html' },
  { id: 8, name: 'Нижнее бельё', slug: 'Underwear', url: 'https://kaspreadsheet.com/search-918/name/Shoes.html' },
  { id: 9, name: 'Джерси', slug: 'Jersey', url: 'https://kaspreadsheet.com/search-919/name/Shoes.html' },
  { id: 10, name: 'Аксессуары', slug: 'Accessories', url: 'https://kaspreadsheet.com/search-920/name/Shoes.html' },
  { id: 11, name: 'Сумки', slug: 'Bags', url: 'https://kaspreadsheet.com/search-921/name/Shoes.html' },
  { id: 12, name: 'Ремни', slug: 'Belts', url: 'https://kaspreadsheet.com/search-922/name/Shoes.html' },
  { id: 13, name: 'Парфюмерия', slug: 'Perfumes', url: 'https://kaspreadsheet.com/search-923/name/Shoes.html' },
  { id: 14, name: 'Прочее', slug: 'Other-Stuff', url: 'https://kaspreadsheet.com/search-924/name/Shoes.html' },
];